'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "value"];
import { trimTree } from 'data-token-picker/utils/drilldown';
import { lazyEval } from 'foundations-components/transitional/utils/lazyEval';
export const makeSearchList = options => {
  return options.map(option => {
    const {
        children,
        value
      } = option,
      rest = _objectWithoutPropertiesLoose(option, _excluded);
    return Object.assign({
      value: children && children.length > 0 ? undefined : value,
      options: children
    }, rest);
  });
};
export const pathToSelection = (target, from = []) => {
  for (let i = 0; i < from.length; ++i) {
    if (from[i].value === target) {
      return [from];
    } else if (from[i].children) {
      const found = pathToSelection(target, from[i].children);
      if (found) {
        return [from, ...found];
      }
    }
  }
  return undefined;
};
export const getCurrentOption = (target, from = []) => {
  for (let i = 0; i < from.length; ++i) {
    if (from[i].value === target) {
      return from[i];
    } else if (from[i].children) {
      const found = getCurrentOption(target, from[i].children);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
};
export const getResetOption = ({
  placeholder,
  resetValue
}, {
  resetOption
}) => {
  const newResetOption = {
    buttonText: lazyEval(placeholder),
    dropdownText: lazyEval(placeholder),
    value: resetValue
  };
  if (!(resetOption && resetOption.buttonText === newResetOption.buttonText && resetOption.value === newResetOption.value)) {
    return {
      resetOption: newResetOption
    };
  }
  return null;
};
export const computeCurrentView = (props, state, updates = {}) => {
  const {
    options
  } = props;
  const {
    searchableOptions,
    value
  } = state;
  const inputValue = typeof updates.inputValue === 'string' ? updates.inputValue : state.inputValue;
  if (options) {
    let filteredOptions;
    let optionsStack;
    if (inputValue) {
      filteredOptions = trimTree(inputValue.toLowerCase(), searchableOptions);
    }
    if (value) {
      optionsStack = pathToSelection(value, options);
    } else {
      optionsStack = [options];
    }
    return {
      filteredOptions,
      optionsStack
    };
  }
  return null;
};
export const initializeOptions = (props, state) => {
  if (props.options) {
    return Object.assign({
      searchableOptions: makeSearchList(props.options)
    }, computeCurrentView(props, state));
  }
  return null;
};